export const reviewCategories = [
  "全部",
  "深度长评",
  "表演解析",
  "摄影美术",
  "主题解读",
  "观众视角",
];

export const reviews = [
  {
    id: "r-001",
    title: "克制之下的暗涌：谈《色戒》的表演美学",
    author: "影迷·林深",
    date: "2026-09-28",
    rating: 9.2,
    category: "表演解析",
    tags: ["表演解析", "深度长评"],
    excerpt:
      "真正动人的表演，从来不是声嘶力竭。影片中大量沉默的注视与欲言又止，构成了最锋利的情感刀锋。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20close-up%20texture%20of%20red%20silk%20fabric%20with%20warm%20golden%20light%2C%20elegant%20abstract%20film%20still%20mood%2C%20deep%20crimson%20tones%2C%20no%20text&width=800&height=600&seq=review-cover-01&orientation=landscape",
    quote: "所有翻涌的情绪，都被压缩进一个眼神里。",
    content: [
      "第一次观看这部影片时，我几乎被它的沉默吓到。镜头长时间停留在人物的脸上，没有台词，没有配乐，只有呼吸与光线在缓慢地流动。可正是在这样的静默中，情绪的暗流反而最为汹涌。",
      "表演的最高境界，往往是克制。演员需要把一个复杂人物内心的全部挣扎，收束到一次抬手、一次垂眸、一次欲言又止里。观众看到的不是情绪的宣泄，而是情绪在爆发前那一瞬间的紧绷。",
      "影片中有一段极为精彩的对手戏：两人隔着一张桌子，谁都没有先开口。窗外的雨声、桌上的茶杯、跳动的烛火，全都成了情绪的延伸。当其中一人终于低声说话时，那种压抑许久后的释放，才真正击中了观众。",
      "这种表演方式对演员的要求极高。它要求演员完全信任镜头，信任观众，也信任留白本身的力量。正是这份信任，让整部影片拥有了超越情节本身的持久感染力。",
      "多年之后重看，我依然会被那些沉默的瞬间击中。或许这就是经典的意义——它不会告诉你答案，却总能在不同的年纪，让你读出不同的重量。",
    ],
  },
  {
    id: "r-002",
    title: "光影里的时代：评影片的镜头语言与美术",
    author: "影评人·陈默",
    date: "2026-09-21",
    rating: 8.9,
    category: "摄影美术",
    tags: ["摄影美术", "深度长评"],
    excerpt:
      "一窗、一帘、一盏灯，都被赋予了叙事的重量。美术与摄影共同搭建起一个既真实又超验的情感空间。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20dim%20elegant%20room%20with%20window%20light%20and%20red%20curtain%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20dramatic%20moody%20atmosphere%2C%20no%20text&width=800&height=600&seq=review-cover-02&orientation=landscape",
    quote: "空间本身，就是一位不会说话的叙事者。",
    content: [
      "如果说表演是影片的心跳，那么美术与摄影就是它的呼吸。影片对时代氛围的还原，几乎到了偏执的程度：窗帘的褶皱、灯罩的暖度、地板的旧痕，每一处细节都经得起放大镜般的审视。",
      "摄影师偏爱使用暖光源与深色背景的对比。人物的面部常常被一束暖光点亮，而身后的空间则沉入阴影之中。这种处理方式不仅突出了人物的孤独感，也让画面具备了油画般的质感。",
      "值得注意的是影片对'门'与'窗'的反复使用。它们既是物理空间的分隔，也暗示着人物内心的封闭与渴望。人物常常站在窗前向外望，可镜头始终没有给窗外的世界，只有被玻璃映出的、模糊的脸。",
      "色彩的运用同样克制而精准。深红、暗金、墨绿构成了影片的基本色调，热烈与压抑在同一画面里共存，仿佛在提醒观众：这是一个危险而又迷人的年代。",
      "当技术与情感达到如此高度统一时，影像便不再是情节的附庸，而成为了独立的审美对象。这才是真正的电影之美。",
    ],
  },
  {
    id: "r-003",
    title: "选择的重量：人物命运与主题解读",
    author: "影迷·苏晚",
    date: "2026-09-12",
    rating: 9.5,
    category: "主题解读",
    tags: ["主题解读", "观众视角"],
    excerpt:
      "每个人都在自己的信念与情感之间艰难权衡。影片没有给出答案，却让观众在离场后久久无法平静。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20symbolic%20film%20still%20of%20a%20lone%20figure%20silhouette%20walking%20in%20a%20dim%20corridor%20with%20red%20glow%2C%20dramatic%20chiaroscuro%20lighting%2C%20moody%20period%20drama%2C%20no%20text&width=800&height=600&seq=review-cover-03&orientation=landscape",
    quote: "最难的选择，往往发生在没有人知道的深夜里。",
    content: [
      "这部影片最打动我的，是它对'选择'的刻画。它没有把任何一个人物塑造成简单的英雄或反派，而是让每个人都背负着自己的理由，走向各自的结局。",
      "影片中的人物始终在两种力量之间摇摆：一种来自外部的要求与责任，另一种来自内心深处的情感与欲望。导演没有评判哪一种更高尚，而是让它们在镜头前平等地呈现，交由观众自行体会。",
      "我尤其喜欢影片的结尾处理。它没有激昂的配乐，也没有煽情的独白，只有一个缓慢拉远的镜头，把一个时代的重量，轻轻地放在观众肩上。",
      "看完之后，我在座位上坐了很久。我在想，如果身处那样的年代，我会做出怎样的选择？我没有答案。而影片的珍贵之处，恰恰在于它尊重这份没有答案。",
      "这或许就是经典影片的魅力——它不提供廉价的安慰，而是邀请你，用一生去反复思考同一个问题。",
    ],
  },
  {
    id: "r-004",
    title: "从一封信说起：影片中的细节伏笔大盘点",
    author: "影迷·周野",
    date: "2026-09-05",
    rating: 8.4,
    category: "深度长评",
    tags: ["深度长评", "细节盘点"],
    excerpt:
      "一封没有寄出的信、一枚反复出现的戒指，都可能在为结局埋下伏笔。本文带你逐帧寻找那些容易被忽略的细节。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20letter%20and%20a%20ring%20on%20a%20wooden%20desk%20under%20warm%20lamp%20light%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20vintage%20atmosphere%2C%20no%20text&width=800&height=600&seq=review-cover-04&orientation=landscape",
    quote: "真正重要的东西，导演往往只给你看一次。",
    content: [
      "重看影片时，我习惯把进度条放慢，逐帧观察画面中的每一处陈设。结果发现，许多看似随意的物件，其实都承担着叙事功能。",
      "比如那枚反复出现的戒指，它第一次出现时只是背景里的一抹反光，第二次出现时被人握在手心，第三次则被留在了空荡的桌上。三次出现，恰好对应了人物关系的三个转折点。",
      "再比如那封始终没有寄出的信。它从未被朗读，观众也无从得知其中的内容，但正是这份'未知'，让观众自动为人物补全了内心的独白。有时候，不告诉反而比告诉更有力量。",
      "影片还反复使用了'镜子'这一意象。人物对着镜子整理衣装、观察表情，镜中的影像与现实中的脸形成微妙的对峙，暗示着人物在'扮演'与'真实'之间的游离。",
      "这些细节之所以动人，是因为它们从不刻意强调自己。它们安静地待在画面的角落里，等待有心人去发现。而每一次发现，都会让观众对作品多一分敬意。",
    ],
  },
  {
    id: "r-005",
    title: "配乐如何成为'无声的主角'",
    author: "乐评人·何以宁",
    date: "2026-08-30",
    rating: 8.7,
    category: "摄影美术",
    tags: ["电影配乐", "艺术赏析"],
    excerpt:
      "好的电影配乐不是情绪的喇叭，而是情感的影子。它总在该出现时出现，在该沉默时彻底消失。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20vintage%20violin%20and%20sheet%20music%20in%20dim%20warm%20light%2C%20deep%20crimson%20accent%2C%20elegant%20moody%20atmosphere%2C%20no%20text&width=800&height=600&seq=review-cover-05&orientation=landscape",
    quote: "最动人的旋律，往往是观众离场后才在心里响起的。",
    content: [
      "很多影片用配乐来提示观众'这里该感动了'，而这部影片恰恰相反。它在大段的情节里保持着近乎冷酷的安静，只在情绪的临界点，才让音乐轻轻浮出水面。",
      "这种克制让配乐的每一次出现都显得格外珍贵。当弦乐终于响起时，观众积蓄已久的情绪找到了出口，那种释放感是任何密集配乐都无法替代的。",
      "更巧妙的是，影片中出现了大量'画内音乐'——留声机、舞厅乐队、街头艺人。这些音乐来自故事内部，既还原了时代氛围，又与人物的处境形成了若即若离的呼应。",
      "印象最深的是舞会那一场。喧闹的音乐与人物内心的疏离形成了强烈反差，越是热闹，越显孤独。",
      "配乐的最高境界，是让观众忘记它的存在，却又无法想像没有它的画面。这部影片做到了。",
    ],
  },
  {
    id: "r-006",
    title: "一个普通观众的三刷记录",
    author: "影迷·小满",
    date: "2026-08-22",
    rating: 8.0,
    category: "观众视角",
    tags: ["观众视角", "观后感"],
    excerpt:
      "第一次看故事，第二次看表演，第三次看自己。同一部电影，为什么每次看都有不同的感受？",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20single%20empty%20red%20velvet%20cinema%20seat%20with%20screen%20glow%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20atmospheric%2C%20no%20text&width=800&height=600&seq=review-cover-06&orientation=landscape",
    quote: "同一部电影，会在不同的人生阶段，长出不同的样子。",
    content: [
      "我不是影评人，只是一名普通观众。第一次看这部影片时，我关心的是故事会怎么收场，看完只觉得心里堵得慌，说不清是为什么。",
      "第二次看，我开始留意演员的表情与动作，才发现原来那么多情绪都藏在台词之外。那一刻，我明白了什么叫'表演'。",
      "第三次看，我几乎是在看自己。影片中人物的那些犹豫、逞强与言不由衷，让我想起了生活里许多似曾相识的瞬间。",
      "我把这部影片推荐给了身边的朋友，每个人看完的感受都不一样。有人说它讲的是爱情，有人说它讲的是时代，也有人说它讲的是一个人的成长。我想，也许他们都没错。",
      "好电影就像一面镜子，你从里面看到的，其实是你自己。这也是我愿意一看再看的原因。",
    ],
  },
  {
    id: "r-007",
    title: "服饰与身份：一件旗袍的叙事功能",
    author: "影评人·陈默",
    date: "2026-08-15",
    rating: 8.6,
    category: "摄影美术",
    tags: ["服饰美学", "细节盘点"],
    excerpt:
      "服装不只是装扮，更是身份的注脚。本文从服饰的变换，读懂人物在故事中的每一次位移。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20elegant%20red%20silk%20qipao%20dress%20hanging%20in%20dim%20warm%20light%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20vintage%20atmosphere%2C%20no%20text&width=800&height=600&seq=review-cover-07&orientation=landscape",
    quote: "每一次换装，都是一次身份的重写。",
    content: [
      "在时代题材的影片中，服装是最直观的时代符号。而在这部影片里，服装更进一步，成为了人物身份与心理的外化。",
      "仔细观察会发现，人物的衣着随着处境的变化而不断调整。款式、颜色、面料的每一次改变，都对应着人物在社会关系中的一次位移。",
      "尤其是深红与墨色的交替使用，几乎构成了人物内心挣扎的视觉隐喻。红，代表着情感与冲动；墨，则象征着克制与隐匿。",
      "最精妙的是，影片从未用台词解释这些变化，而是让观众在不知不觉中感受到人物处境的迁移。这是视觉叙事的魅力。",
      "当一件服装可以独立承担叙事功能时，它便不再是道具，而成为了作品的一部分。",
    ],
  },
  {
    id: "r-008",
    title: "为什么说这是'被低估'的一部作品",
    author: "影评人·许一",
    date: "2026-08-08",
    rating: 9.0,
    category: "深度长评",
    tags: ["深度长评", "主题解读"],
    excerpt:
      "当年上映时，讨论多集中在话题性上，反而遮蔽了作品本身的艺术野心。本文试图还它一个更公允的评价。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20film%20projector%20casting%20warm%20light%20in%20a%20dim%20room%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20nostalgic%20atmosphere%2C%20no%20text&width=800&height=600&seq=review-cover-08&orientation=landscape",
    quote: "有些作品，需要时间才能显出它真正的分量。",
    content: [
      "一部作品刚出现时，往往会被当时的舆论裹挟。人们热衷于讨论它的话题性，却容易忽略它在艺术上真正的追求。",
      "如今回看，这部影片在叙事结构、视听语言与表演调度上的完整度，都远超同期的许多作品。它胆子很大，也足够真诚。",
      "它敢于把镜头对准那些难以言说的灰色地带，敢于让观众在道德判断上'不舒服'。这种不舒服，恰恰是严肃艺术的标志。",
      "时间是最好的评论家。当喧嚣散去，留下来的，是那些经得起反复审视的细节与情感。",
      "我相信，随着时间的推移，这部作品会获得越来越多观众的重新认识。",
    ],
  },
  {
    id: "r-009",
    title: "写给第一次看它的你：五条观影建议",
    author: "影迷·周野",
    date: "2026-08-01",
    rating: 7.8,
    category: "观众视角",
    tags: ["观影指南", "观众视角"],
    excerpt:
      "不必急着寻找标准答案。把节奏交给影片，把判断留给自己，或许才是打开这部作品最好的方式。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20two%20empty%20theater%20seats%20facing%20a%20glowing%20screen%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20nostalgic%20atmosphere%2C%20no%20text&width=800&height=600&seq=review-cover-09&orientation=landscape",
    quote: "不要急着理解，先试着感受。",
    content: [
      "如果你正准备第一次观看这部影片，我想给你几个小小的建议，或许能让你的观影体验更完整。",
      "第一，找一个安静的环境，关掉手机。这是一部需要耐心的作品，任何打断都会削弱它的感染力。",
      "第二，不要急着在网上搜索'剧情解析'。让影片自己向你展开，你的第一感受比任何影评都珍贵。",
      "第三，留意那些没有台词的段落。它们往往才是影片真正想说的话。",
      "第四，允许自己'看不懂'。有些作品的意义，不在看懂，而在被触动。第五，看完之后，给自己一点独处的时间，让情绪慢慢沉淀。",
      "希望你能在影片里，遇见属于你自己的那份感动。",
    ],
  },
];